import { render } from "./Properties.vue?vue&type=template&id=71e3a37c&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"

import "./Properties.vue?vue&type=style&index=0&id=71e3a37c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e3a37c"]])

export default __exports__